import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import { buscarVentas } from '../../actions/ventas';
import { buscarSucursales } from '../../actions/sucursales';
import { buscarMetodosTipo } from '../../actions/metodos';
import { buscarEmpleados } from '../../actions/empleados';
import { buscarEventos } from '../../actions/eventos';
import { buscarProductosConfiguracion } from '../../actions/configuracion';
import { editarBreadcrumb } from '../../actions/breadcrumb';
import { formatNumber } from '../../utils/generalFunctions';

import FiltrosVenta from './FiltrosVenta';

const filtrosVacios = {
    folio: '',
    fecha_inicio: null,
    fecha_fin: null,
    status: null,
    sucursal: null,
    metodo: null,
    vendedor: null,
    evento: null,
    tipo: null,
    productos: []
};

const Ventas = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const listado = useSelector(state => state.ventas.listado);

    const [filtrosModal, setFiltrosModal] = useState(false);
    const [filtros, setFiltros] = useState(filtrosVacios);

    useEffect(() => {
        dispatch(buscarVentas(filtrosVacios));
        dispatch(buscarSucursales());
        dispatch(buscarMetodosTipo(4));
        dispatch(buscarEmpleados());
        dispatch(buscarEventos(false));
        dispatch(buscarProductosConfiguracion());
        dispatch(editarBreadcrumb([
            { nombre: 'Ventas', path: '/ventas', activo: true }
        ]));
    }, []);

    const handleAplicarFiltros = (nuevosFiltros) => {
        setFiltros(nuevosFiltros);
        dispatch(buscarVentas(nuevosFiltros));
    };

    const filtrosActivos = [
        filtros.folio,
        filtros.fecha_inicio,
        filtros.fecha_fin,
        filtros.status !== null,
        filtros.sucursal,
        filtros.metodo,
        filtros.vendedor,
        filtros.evento,
        filtros.tipo,
        filtros.productos?.length > 0
    ].filter(Boolean).length;

    const columns = [
        {
            name: 'Folio',
            sortable: true,
            wrap: true, 
            selector: row => row.folio || '-'
        },
        {
            name: 'Fecha',
            sortable: true,
            wrap: true, 
            selector: row => row.fecha
                ? new Date(row.fecha).toLocaleString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
                : '-',
            grow: 1.5
        },
        {
            name: 'Total',
            sortable: true,
            wrap: true, 
            selector: row => row.total != null ? formatNumber(row.total, 2, '$', '') : '-'
        },
        {
            name: 'Status',
            sortable: true,
            wrap: true, 
            cell: row => (
                <span className={`badge ${row.status === true ? 'bg-success' : 'bg-danger'}`}>
                    {row.status === true ? 'Realizada' : 'Cancelada'}
                </span>
            )
        },
        {
            name: 'Sucursal',
            sortable: true,
            wrap: true, 
            selector: row => row.sucursal?.nombre || '-',
            grow: 1.5
        },
        {
            name: 'Método',
            sortable: true,
            wrap: true, 
            selector: row => row.metodo?.nombre || '-'
        },
        {
            name: 'Vendedor',
            sortable: true,
            wrap: true, 
            selector: row => row.vendedor
                ? `${row.vendedor.nombre || ''} ${row.vendedor.apellido_paterno || ''} ${row.vendedor.apellido_materno || ''}`.trim()
                : '-',
            grow: 1.5
        },
        {
            name: 'Evento',
            sortable: true,
            wrap: true,
            selector: row => row.evento?.nombre || '-',
            grow: 1.5
        },
        {
            name: 'Tipo',
            sortable: true,
            cell: row => {
                if (row.cortesia) return <span className="badge bg-info text-dark">Cortesía</span>;
                if (row.especial) return <span className="badge bg-warning text-dark">Especial</span>;
                return <span className="badge bg-secondary">Normal</span>;
            }
        },
        {
            name: 'Acciones',
            cell: row => (
                <Link className="btn btn-sm btn-info" to={`/ventas/informacion/${row._id}`}>
                    <i className="fas fa-eye"></i>
                </Link>
            )
        }
    ];

    return (
        <div className="row mt-5">
            <div className="col-12 mb-4 d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Ventas</h4>
                <button className="btn btn-secondary position-relative" onClick={() => setFiltrosModal(true)}>
                    <i className="fas fa-filter me-1"></i> Filtros
                    {filtrosActivos > 0 && (
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
                            {filtrosActivos}
                        </span>
                    )}
                </button>
            </div>

            <div className="col-12">
                <DataTable
                    columns={columns}
                    data={listado}
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' }}
                    highlightOnHover
                    noDataComponent="No hay ventas registradas"
                />
            </div>

            <FiltrosVenta
                show={filtrosModal}
                handleCerrar={() => setFiltrosModal(false)}
                filtros={filtros}
                handleAplicar={handleAplicarFiltros}
            />
        </div>
    );
};

export default Ventas;
